import { BrowserRouter, Route, Routes } from "react-router-dom";
import RedirectionPage from "./pages/landing";
import PageNotFound from "./pages/PageNotFound";
import LinkIssues from "./pages/linkIsuues";

function App() {
  // <PaymentSuccess
  //   amount={"adf"}
  //   paymentType={"dsf"}
  //   transactionNo={"ewr"}
  //   status={"erq"}
  //   applicationNo={"reuy"}
  // />
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/payment-response/:id" element={<RedirectionPage />} />
          <Route path="/payment-response" element={<LinkIssues />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
